module.exports = __webpack_public_path__ + "img/three.f08b7b56.png";